import { PIC } from '../templates/Internals';
if (!window.loadPage)
    window.loadPage = loadPage;
export function loadPage(APIUrl, Params, options) {
    var _a;
    let modalElm, loadPageElm, createNew, closeEvent, isNew, parentSessId, drawMode;
    isNew = PIC.getInstance.webVersion == '3';
    if (options) {
        if (options.closeEvent && options.closeEvent !== '?')
            closeEvent = options.closeEvent;
        if (options.isNew && isNew == undefined)
            isNew = options.isNew;
        if (options.parentSessId)
            parentSessId = options.parentSessId;
        if (options.drawMode)
            drawMode = options.drawMode;
    }
    if (!Params)
        Params = '';
    if (isNew) {
        loadPageElm = document.createElement('pic-loadpage');
        loadPageElm.setAttribute('apiurl', APIUrl);
        loadPageElm.setAttribute('params', Params);
        loadPageElm.setAttribute('isNew', 'true');
        loadPageElm.setAttribute('system', (_a = options === null || options === void 0 ? void 0 : options.system) !== null && _a !== void 0 ? _a : '');
        if (drawMode)
            loadPageElm.setAttribute('drawMode', drawMode);
        if (closeEvent)
            loadPageElm.setAttribute('closeEvent', closeEvent);
        document.body.appendChild(loadPageElm);
        loadPageElm.parentSessId = parentSessId;
        loadPageElm.isFirstLoad = true;
        loadPageElm.handleLoad();
    }
    else {
        modalElm = document.createElement('pic-modal');
        loadPageElm = document.createElement('pic-loadpage');
        modalElm.setAttribute('width', '80vw');
        modalElm.setAttribute('height', '80vh');
        loadPageElm.setAttribute('type', 'pic-loadpage');
        loadPageElm.setAttribute('apiurl', APIUrl);
        loadPageElm.setAttribute('params', Params);
        loadPageElm.setAttribute('system', PIC.systemId);
        loadPageElm.setAttribute('width', '60vw');
        loadPageElm.setAttribute('height', '60vh');
        if (closeEvent)
            loadPageElm.setAttribute('closeEvent', closeEvent);
        modalElm.appendChild(loadPageElm);
        document.body.appendChild(modalElm);
        loadPageElm.parentSessId = parentSessId;
        loadPageElm.isFirstLoad = true;
        loadPageElm.handleLoad();
    }
}
;
//# sourceMappingURL=loadpage.js.map